import type { Locale } from '@mfw/translations';

import { formatRegionDate } from './regionDate';

export interface FormatOptions {
  withoutTime?: boolean;
  locale: Locale;
}

export function format(date: Date | string, options: FormatOptions): string {
  return formatRegionDate(date, options.locale, {
    day: 'numeric',
    ...(options.withoutTime ? {} : { hour: '2-digit', minute: '2-digit' }),
    month: 'short',
    year: 'numeric',
  });
}
